import React from 'react';
import './LoadingScreen.css';

// Ecran affiche pendant la verification de session au demarrage (au lieu
// d'un blanc vide) — sur les 4 portails (company/supervisor/sub-supervisor/
// superadmin), cf. components/Require*Auth.jsx.
const LoadingScreen = () => (
  <div className="ls-overlay">
    <img className="ls-logo" src="/logo-cgl.png" alt="CGL Multi-services" />
    <div className="ls-bar"><div className="ls-bar-fill" /></div>
  </div>
);

export default LoadingScreen;
